// extracted by mini-css-extract-plugin
module.exports = {"Video":"Video_Video__b-Hlw","VideoTitle":"Video_VideoTitle__2x290"};